export default class UpscopeError<T> extends Error {
  message: string;
  response?: T;
  status?: number;

  constructor({ message, response, status }: { message: string; response?: T; status?: number }) {
    super();
    this.message = message;
    this.response = response;
    this.status = status;
  }
}
